<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>资源互推记录</span>
          </div>
          <el-form :model="searchData" :inline="true">
            <el-form-item label="推送方式(必选)">
              <el-radio
                v-for="item in pushTypeList"
                v-model="searchData.type"
                :key="item.value"
                :label="item.value"
                border>
                {{ item.label }}
              </el-radio>
            </el-form-item>
            <br>
            <template v-if="searchData.type">
              <el-form-item label="来源系统客户编码">
                <el-input v-model="searchData.from_userid" clearable />
              </el-form-item>
              <el-form-item label="接收系统客户编码">
                <el-input v-model="searchData.to_userid" clearable />
              </el-form-item>
              <el-form-item label="推送时间">
                <el-date-picker
                  v-model="searchData.create_time"
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  class="jm-input280"/>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="searchData.tel" clearable />
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="searchData.username" clearable />
              </el-form-item>
              <el-form-item label="昵称">
                <el-input v-model="searchData.nickname" clearable />
              </el-form-item>
              <el-form-item label="qq">
                <el-input v-model="searchData.qq" clearable />
              </el-form-item>
              <el-form-item label="微信">
                <el-input v-model="searchData.wechat" clearable />
              </el-form-item>
              <el-form-item label="是否重复资源推送">
                <el-select
                  v-model="searchData.is_duplicate"
                  clearable
                  placeholder="请选择">
                  <el-option
                    :key="1"
                    label="是"
                    :value="1"/>
                  <el-option
                    :key="0"
                    label="否"
                    :value="0"/>
                </el-select>
              </el-form-item>
              <el-form-item label="接收人">
                <el-autocomplete
                  clearable
                  value-key="truename"
                  v-model="searchData.receiverValue"
                  :fetch-suggestions="fetchUser"
                  placeholder="请输入内容"
                  :trigger-on-focus="false"
                  @select="(item) => selectReceiver(item, 'receiver')"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="推送人">
                <el-autocomplete
                  clearable
                  value-key="truename"
                  v-model="searchData.senderValue"
                  :fetch-suggestions="fetchUser"
                  placeholder="请输入内容"
                  :trigger-on-focus="false"
                  @select="(item) => selectReceiver(item, 'sender')"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="接收部门">
                <el-select
                  v-model="searchData.receiver_department"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in departmentList"
                    :key="item.id"
                    :label="item.department"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="推送部门">
                <el-select
                  v-model="searchData.sender_department"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in departmentList"
                    :key="item.id"
                    :label="item.department"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="渠道来源">
                <jm-channel
                  v-if="isFibSite"
                  v-model="searchData.channels"
                  :is-all="false"
                  :final.sync="channelFinal"
                  clearable
                  ref="channelRef"
                  filterable/>
              </el-form-item>
              <el-form-item label="签约日期" v-if="level_flag">
                <el-date-picker
                  v-model="searchData.sign_date"
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  class="jm-input280"/>
              </el-form-item>
              <el-form-item label="客户分级" v-if="level_flag">
                <el-select clearable v-model="searchData.crm_level_lv" v-if="this.level_flag_sub" placeholder="请选择">
                  <el-option
                    v-for="item in crm_level_lv1"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                  </el-option>
                </el-select>
                <el-select clearable v-model="searchData.crm_level_lv" v-else placeholder="请选择">
                  <el-option
                    v-for="item in crm_level_lv2"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="来源系统当时的客户状态">
                <jm-dict-select
                  v-if="[1,2].indexOf(searchData.type) > -1"
                  clearable
                  type="dataset"
                  v-model="searchData.from_level"
                  class="jm-input280"
                  dict-type="student"
                  name="customLvType"/>
                <jm-dict-select
                  v-else
                  clearable
                  v-model="searchData.from_level"
                  class="jm-input280"
                  type="dataset"
                  dict-type="training"
                  name="trainingLevelType"
                />
              </el-form-item>
            </template>

            <div class="searchBottom">
              <el-button
                class="jm-input-common3"
                type="primary"
                :disabled="!searchData.type"
                @click="handleSearch">查询</el-button>
              <el-button
                class="jm-input-common3"
                type="success"
                :loading="exporting"
                :disabled="!searchData.type"
                v-if="$hasPermission([1, 91])"
                @click="exportSyncLog">导出数据</el-button>
            </div>
          </el-form>
          <jm-table-list
            v-if="searchData.type && lockTable"
            ref="stable"
            url="/training/customer/syncLogList"
            :search-data="searchData"
            :refresh.sync="refresh"
            row-key="id">
            <el-table-column
              slot="note"
              slot-scope="scope"
              label="文字说明"
              property="note">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.note"
                  placement="top-start">
                  <span class="white-nowrap">{{ scope.row.note }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </jm-table-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jmDictSelect from '@/components/tool/select/dictSelect.vue';
import jmTableList from '@/components/data/tableList.vue';
import { jmChannel } from '@/components/tool';
import { pushType } from '@/dataset/training';

export default {
  name: 'ResourceSyncLog',
  data() {
    return {
      exporting: false,
      refresh: false,
      searchData: {},
      departmentList: [],
      channelFinal: false,
      level_flag: false,
      level_flag_sub: false,
      crm_level_lv1: [
        { key: 57, value: '已签约' },
      ],
      crm_level_lv2: [
        { key: 7, value: '已报名' },
      ],
      lockTable: false, // 是否显示表格
    };
  },
  computed: {
    pushTypeList() {
      return pushType.filter((opt) => {
        if (opt.value > 3) {
          return false;
        }
        if (this.$hasPermission(91, true)) {
          return opt.label.indexOf('星图') !== -1;
        }
        return true;
      });
    }
  },
  methods: {
    handleSearch() {
      if (!this.searchData.type) {
        this.$message.error('请选择推送方式');
        return;
      }
      this.lockTable = true;
      this.refresh = true;
    },
    fetchUser(truename, cb) {
      this.$http._post({
        url: '/index/api_base/searchTeacher',
        data: {
          truename
        }
      }).then(({ data }) => {
        cb(data);
      });
    },
    selectReceiver(item, name) {
      this.searchData[name] = item.userid;
    },
    exportSyncLog() {
      this.exporting = true;
      this.$http._post({
        url: '/training/customer/exportSyncLog',
        data: { searchData: this.searchData },
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '合并记录.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    },
    getDepartmentList() {
      this.$http._post({
        url: '/index/system/departments',
      }).then((res) => {
        const { departments } = res.data;
        this.departmentList = departments;
      });
    },
  },
  components: {
    jmDictSelect,
    jmTableList,
    jmChannel
  },
  watch: {
    'searchData.senderValue'(value) {
      if (!value) {
        this.searchData.sender = '';
      }
    },
    'searchData.receiverValue'(value) {
      if (!value) {
        this.searchData.receiver = '';
      }
    },
    'searchData.type'(val) {
      if (val === 1 || val === 2) {
        this.level_flag = true;
        this.level_flag_sub = false;
      } else if (val === 3) {
        this.level_flag = true;
        this.level_flag_sub = true;
      } else {
        this.level_flag = false;
      }
    }
  },
  created() {
    this.getDepartmentList();
  },
};
</script>
